import ipRegex from "ip-regex";

export default function ip(input: string): string {
  if (input === "") {
    return "";
  }

  if (!ipRegex({ exact: true }).test(input)) {
    return "Please input a valid ip address. Example: 127.0.0.1";
  }

  return "";
}
